import * as Dialog from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';
import { Icon } from './icon';

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  maxWidth = 720,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  maxWidth?: number;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 animate-fade-in z-40" />
        <Dialog.Content
          data-fc-modal
          className="fixed z-50 card bg-paper dark:bg-dark-paper text-fg dark:text-dark-fg shadow-2xl animate-fade-in flex flex-col inset-0 w-screen h-[100dvh] max-w-none rounded-none md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-[94vw] md:h-auto md:max-h-[90vh] md:rounded-lg md:[max-width:min(94vw,var(--modal-max-w))]"
          style={{ ['--modal-max-w' as any]: typeof maxWidth === 'number' ? maxWidth + 'px' : maxWidth } as React.CSSProperties}
        >
          <div className="flex items-start justify-between px-4 md:px-5 pt-4 md:pt-5 pb-3 border-b border-line dark:border-dark-line">
            <div>
              <Dialog.Title className="text-lg font-semibold">{title}</Dialog.Title>
              {description && (
                <Dialog.Description className="text-sm text-fg dark:text-dark-fg mt-1">{description}</Dialog.Description>
              )}
            </div>
            <Dialog.Close className="p-1.5 rounded hover:bg-line/50 dark:hover:bg-dark-line/50 transition">
              <Icon name="x" size={18} />
            </Dialog.Close>
          </div>
          <div className="p-4 md:p-5 flex-1 overflow-y-auto scroll-thin md:max-h-[70vh] pb-safe">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
